import { Flex, Layout } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from 'app/hooks';
import useScrollToTop from 'hooks/useScrollToTop';
import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
import { GlobalToastAlert } from 'components/ToastAlert';
import { PageLoader } from 'components/Spin';
import { selectIsBrandDetailsExist } from 'services/brand/brandSelectors';
import styles from './Layout.module.scss';

function LayoutWithSider() {
  const location = useLocation();
  useScrollToTop(location.pathname);

  const isBrandDetailsExist = useAppSelector(selectIsBrandDetailsExist);

  if (!isBrandDetailsExist) {
    return <PageLoader />;
  }

  return (
    <Flex gap='middle' wrap='wrap'>
      <Layout className={styles.container}>
        <div className={styles.stickyContainer}>
          <Header />
          <GlobalToastAlert />
        </div>
        <Outlet />
        <Footer />
      </Layout>
    </Flex>
  );
}

export default LayoutWithSider;
